import type { RefObject } from 'react';
import { useEffect } from 'react';

export const useInfinityScroll = <T extends HTMLElement = HTMLElement>(
  ref: RefObject<T>,
  onNext: () => void,
) => {
  useEffect(() => {
    const target = ref?.current;
    if (!target) return undefined;
    const scrollHandler = () => {
      const shouldFetchNext = target.scrollHeight - (target.scrollTop + target.offsetHeight) <= 1;
      if (shouldFetchNext) {
        onNext();
      }
    };
    target.addEventListener('scroll', scrollHandler);
    return () => target.removeEventListener('scroll', scrollHandler);
  }, [ref, onNext]);
};
